import { Radio } from 'antd';

var group = Radio.Group;

export { group as default };
